import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import CardSimple from 'screens/components/basic/CardSimple';
import Body from './Body';
import Header from './Header';
import { getAggregateSales, getCsvReport } from 'actions/ReportsAction';
import { formInput, clearFormInput } from 'actions/FormActions';
import Grid from 'screens/components/basic/Grid';
import { reportAggregateSales } from 'utils/breadcrumbInfo';
import KnowledgeBase from 'screens/components/basic/KnowledgeBaseIcon';
import PageHeader from 'screens/components/basic/PageHeader';
import { showError } from 'actions/CommonActions';
import { checkDateRange } from 'utils/helpers';
import WithRouter from 'custom/withRouter';

class AggregateSales extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 20,
            showBody: false,
            totalRow: 0,
            model: {
                beginDate: 0,
                endDate: 0,
                branch: 0
            }
        };

        this.showBody = this.showBody.bind(this)
    }

    componentWillMount() {
        const date = new Date()
        this.props.formInput(new Date(date.getFullYear(), date.getMonth(), 1),
            `AggregateSalesBeginDate`);
        this.props.formInput(date, `AggregateSalesEndDate`)
    }

    filter = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    showBody() {
        if (checkDateRange(this.props.beginDate, this.props.endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.filter();
            this.setState({ showBody: true });
        }
    }

    getReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let group = this.props.group || 2;

        this.props.getAggregateSales({ beginDate, endDate, group });
    }

    downloadReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let group = this.props.group || 2;
        if (checkDateRange(beginDate, endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.props.getCsvReport(`reports/excel/aggregatesales?beginDate=${beginDate}&endDate=${endDate}&groupby=${group}`, "aggregatesales");
        }
    }

    redirectToReport = () => {
        this.props.navigate("/report");
    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getReport);
    }

    render() {
        return (
            <Grid headerContent={reportAggregateSales}>
                <PageHeader title={LOOKUP.report.aggregateSales.text} 
                    icon={<KnowledgeBase link="https://knowledge.techpos.ca/en/knowledge/what-is-the-aggregate-sales-report" />}
                    description={LOOKUP.report.aggregateSales.description}
                />
                <Header
                    loggedBranch={this.props.loggedBranch} branchOptions={this.props.brachOptions} groupOptions={this.props.groupOptions} filter={this.filter} download={this.downloadReport} showBody={this.showBody} />
                    {
                        this.state.showBody &&
                        <p className="text-right mt-2 purpleText">
                            <i>Generated on : {moment().format('MMMM Do YYYY, h:mm:ss a')}</i>
                        </p>
                    }
                    {
                        this.state.showBody && this.props.aggregateSales &&
                        <CardSimple>
                            <Body aggregateSales={this.props.aggregateSales} branchOptions={this.props.brachOptions} beginDate={this.props.beginDate} endDate={this.props.endDate} />
                        </CardSimple>
                    }
            </Grid>
        );
    }
}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let brachOptions = [];
    let groupOptions = [
        {
            text: "Year", value: "1"
        },
        {
            text: "Month", value: "2"
        },
        {
            text: "Day", value: "3"
        }
    ]
    branches.map((item) => {
        brachOptions.push({
            text: item.name, value: item.id.toString()
        });
    })
    return {
        brachOptions: brachOptions,
        aggregateSales: state.reports.aggregateSales,
        loggedBranch: state.common.branchId,
        beginDate: state.form.AggregateSalesBeginDate,
        endDate: state.form.AggregateSalesEndDate,
        group: state.form.AggregateSalesGroup,
        groupOptions
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getAggregateSales: model => dispatch(getAggregateSales(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        showError: (message) => dispatch(showError(message)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(AggregateSales));